.trigger {
  width: 1.125rem;
  height: 1.125rem;
  flex: 0 0 1.125rem;
  border-radius: var(--radius-xs);
  color: var(--color-fg);
  pointer-events: auto;
}

.trigger:hover,
.trigger[data-expanded] {
  background: var(--color-accent-soft);
  color: var(--color-accent);
}

.trigger svg {
  width: 0.875rem;
  height: 0.875rem;
}

.content {
  width: min(21rem, calc(100vw - 2rem));
  padding: var(--space-3);
  border-radius: var(--radius-lg);
  transform-origin: var(--kb-popover-content-transform-origin);
  animation: settingsIn var(--duration-fast) var(--ease-out);
  pointer-events: auto;
}

.title {
  margin: 0 0 var(--space-3);
  color: var(--color-fg-strong);
  font-family: var(--font-data);
  font-size: var(--text-sm);
  font-weight: 600;
}

.fieldset {
  min-width: 0;
  margin: 0;
  padding: 0;
  border: 0;
}

.legend {
  margin-bottom: var(--space-2);
  font-weight: 600;
}

.kernelGrid {
  display: grid;
  gap: var(--space-2);
}

.kernelOption {
  position: relative;
  display: grid;
  grid-template-columns: 4rem minmax(0, 1fr);
  align-items: center;
  gap: var(--space-3);
  min-height: 3.5rem;
  padding: var(--space-2);
  border: 2px solid var(--color-border-control);
  border-radius: var(--radius-md);
  background: rgba(5, 7, 13, 0.18);
  cursor: pointer;
  transition:
    border-color var(--duration-fast) ease,
    background-color var(--duration-fast) ease;
}

.kernelOption:hover,
.kernelSelected {
  border-color: var(--color-border-hover);
  background: var(--color-accent-soft);
}

.kernelOption:focus-within {
  outline: 2px solid color-mix(in oklab, var(--color-focus) 52%, transparent);
  outline-offset: 2px;
}

.preview {
  width: 4rem;
  height: 1.75rem;
  overflow: visible;
}

.previewAxis,
.previewCurve {
  fill: none;
  vector-effect: non-scaling-stroke;
}

.previewAxis {
  stroke: rgba(226, 232, 240, 0.2);
  stroke-width: 1;
}

.previewCurve {
  stroke: var(--color-accent);
  stroke-width: 1.5;
  stroke-linecap: round;
  stroke-linejoin: round;
}

.kernelText {
  display: grid;
  min-width: 0;
  gap: var(--space-0-5);
}

.kernelText strong {
  color: var(--color-fg-strong);
  font-size: var(--text-sm);
  font-weight: 600;
}

.kernelText small {
  color: var(--color-muted);
  font-size: var(--text-xs);
}

.arrow {
  fill: var(--glass-fill-strong);
  stroke: var(--glass-border);
}

@keyframes settingsIn {
  from {
    opacity: 0;
    transform: scale(0.98) translateY(-0.125rem);
  }
}

@media (pointer: coarse) {
  .trigger {
    width: 1.75rem;
    height: 1.75rem;
    flex-basis: 1.75rem;
  }
}
